<template>
    <painel-component :itens="itensOne">

        <row-component>
            <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'">
                <label>Nome:</label>
                <input-component :type-input="'text'" v-model="formData.name"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'">
                <label>Status:</label>
                <Multiselect v-model="formData.status" :options="selectActiveInative" :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-4'">
                <button-submit @submit="submit" :items="buttonSubmit" class="me-2"/>
                <button-route v-if="buttonCheck.create" :items="buttonRoute"/>
            </row-col-component>
        </row-component>

        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col" style="width: 20%">Criador:</th>
                <th scope="col" style="width: 30%">Nome:</th>
                <th scope="col" style="width: 20%">Status:</th>
                <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit">
                    Ações
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(budget_template, index) in budget_template.data" :key="index">
                <td data-label="Nome">
                    <img v-if="budget_template.photo_creator" class="avatar__image mx-1"
                         :src="budget_template.photo_creator" alt="">
                    <img v-else class="avatar__image mx-1" src="@/assets/images/avatar.png" alt="">
                    {{ budget_template.creator_user_name }}
                </td>
                <td data-label="Nome">{{ budget_template.name }}</td>
                <td data-label="Status">{{ statusString(budget_template.status) }}</td>
                <td data-label="Ações">
                    <button-edit v-if="buttonCheck.edit" :route="'budget-template-edit'" :id-param="budget_template.id"/>
                    <button-show v-if="buttonCheck.show" :route="'budget-template-show'" :id-param="budget_template.id"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="budget_template" :offset="3" @paginate="loadBudgetTemplates"/>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonShow from '@/components/buttons/ButtonShow';
import {useToast} from "vue-toastification";
import ButtonPagination from "@/components/buttons/ButtonPagination.vue";

const toast = useToast()

export default {
    name: 'BudgetTemplateSearch',

    created() {
        this.$store.dispatch('updateNamePage', 'Modelo de Orçamento')
        this.checkACL()
        this.loadBudgetTemplates(1)
    },

    components: {
        ButtonPagination,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        ButtonEdit,
        ButtonShow
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "ti-list"
            },

            buttonSubmit: {
                icon: 'ti-search',
            },

            buttonRoute: {
                icon: 'ti-plus',
                route: '/budget-template/create'
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            formData: {
                name: '',
                status: ''
            },

            searchSubmit: false,
        }
    },

    methods: {

        submit() {
            this.loadBudgetTemplates(1)
            this.searchSubmit = true
        },

        statusString(value) {
            if (value === '1')
                return 'Ativo'
            return 'Inativo'
        },

        loadBudgetTemplates(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch('loadBudgetTemplates', {...this.params, page})
                    .then((r) => {
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data == '') {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 2000});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 12)
                .then((r) => {
                    if (r.data.indexOf('budget-template-search') !== -1) {

                        if (r.data.indexOf('budget-template-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('budget-template-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('budget-template-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        budget_template() {
            return this.$store.state.budget_template.items
        },

        params() {
            return {
                page: this.budget_template.current_page,
                name: this.formData.name,
                status: this.formData.status
            }
        },
    }

}
</script>

<style src="@/assets/style/table.css">

</style>

<style scoped>
.avatar__image {
    width: 30px;
}
</style>
